module.exports = __webpack_public_path__ + "img/ptyfbg03.f5ea201c.png";